// copyTextWithToastr.js
'use strict';
import pushToastr from '../action/pushToastr.js';
import copyTextToClipboard from '../resource/copyTextToClipboard.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

/**
 * Copy text to clipboard
 * @kind action
 * @param {string} {copiedText} - text which should be copied to clipboard
 * @param {string} {successfulTextKey} - i18n text key for copy successfully.
 * @param {string} {failedTextKey} - i18n text key for copy fail.
 * @param {string} {textKeyNamespace} - namespace for successful/failed text key i18n.
 * @param {string} {durationSec} - duration seconds of display.
 * @return {Promise} Action promise.
 */
const copyTextWithToastr =
  ({
    copiedText,
    successfulTextKey,
    failedTextKey,
    textKeyNamespace = TranslationNamespace.NOTIFICATION,
    durationSec = 2,
    color = 'success',
  }) =>
  async dispatch => {
    try {
      await copyTextToClipboard(copiedText);
      dispatch(
        pushToastr({
          textKey: successfulTextKey,
          textKeyOption: { ns: textKeyNamespace },
          durationSec,
          color,
        })
      );
    } catch (error) {
      dispatch(
        pushToastr({
          textKey: failedTextKey,
          textKeyOption: { ns: textKeyNamespace },
          durationSec,
          color: 'error',
        })
      );
    }
  };

export default copyTextWithToastr;
